module.exports = __webpack_public_path__ + "img/tiff-x-dan.7c57c893.jpg";